import t from 'tcomb';

// Tag AQL leaf type. Two distinct shapes per Spec 006/006.1:
//
//   3-key term-list:  { taxonomy_id, operator, term_id | term_ids }
//   2-key presence:   { taxonomy_id, operator }
//
// Operators supported (matching Conditions classes shipped Spec 006/006.1):
//   $tag_is, $tag_is_one_of, $tag_is_all_of, $tag_is_none_of  (3-key)
//   $has_any_tag, $has_no_tag                                  (2-key)
//
// The byte shape is pinned server-side by
// services/hub/spec/unit/lib/targeting/tag_conditions_spec.rb.

const TermListInterface = t.interface({
  taxonomy_id: t.String,
  operator:    t.String,
  term_id:     t.maybe(t.String),
  term_ids:    t.maybe(t.list(t.String))
}, { strict: true });

const PresenceInterface = t.interface({
  taxonomy_id: t.String,
  operator:    t.String
}, { strict: true });

const Tag = t.union([TermListInterface, PresenceInterface], 'Tag');

export default Tag;
